import Pagination from '@mui/material/Pagination';
import { PropTypes } from 'prop-types';

const root = {
  '& ul': {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '10px',
  },
  '& .Mui-selected': {
    backgroundColor: '#24a0ed !important',
    color: '#FFFFFF !important',
    opacity: 0.8,
    fontWeight: 600,
    fontFamily: 'Inter',
    fontSize: 14,
    '&:hover': { background: '#828282' },
  },
  '& ul > li:not(:first-of-type):not(:last-child) > button:not(.Mui-selected)':
    {
      backgroundColor: 'transparent',
      fontFamily: 'Inter',
      color: '#000',
      opacity: 0.7,
      fontSize: 14,
      fontWeight: 600,
      display: 'flex',
      justifyContent: 'center',
      '&:hover': { background: '#828282' },
    },
};

const PaginationComponent = props => {
  const { count, numberOfRowsPerPage, onPageClick } = props;
  const pagecount = Math.ceil(count / numberOfRowsPerPage);
  return (
    <Pagination
      count={pagecount}
      size="medium"
      sx={root}
      onChange={(event, value) => {
        onPageClick(value);
      }}
    />
  );
};

PaginationComponent.propTypes = {
  setPageNumber: PropTypes.func,
  numberOfRowsPerPage: PropTypes.number,
  datalength: PropTypes.number,
};
export default PaginationComponent;
